import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./containers/App/store";
import App from './containers/App/App';
import * as serviceWorker from './serviceWorker';


ReactDOM.render(

  <Provider store={store}>

    <BrowserRouter>
      <Route path={`${process.env.REACT_APP_BASE_URL}`} component={App} />
    </BrowserRouter>

  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();